const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap min-h-[48px] transition-[transform,background-color,border-color,color,box-shadow] duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] active:scale-[0.98] disabled:opacity-60 disabled:pointer-events-none";

export const buttonStyles = {
  gold: `${base} bg-gold text-navy shadow-gold hover:-translate-y-0.5 hover:bg-gold-hover px-6`,
  outlineLight: `${base} border border-white/30 text-white hover:-translate-y-0.5 hover:border-gold-soft hover:text-gold-soft px-6`,
  outlineDark: `${base} border border-navy/20 text-navy hover:-translate-y-0.5 hover:border-navy px-6`,
  navy: `${base} bg-navy text-white hover:-translate-y-0.5 hover:bg-navy-800 px-6`,
  textGoldLink:
    "inline-flex items-center gap-2 font-semibold text-gold-soft underline-offset-4 hover:underline transition-colors duration-150",
  textNavyLink:
    "inline-flex items-center gap-2 font-semibold text-navy underline-offset-4 hover:underline transition-colors duration-150",
};
